var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
import { TRIP_STATE_FRAGMENT } from '../tripstate';
const SELECT_FLIGHT_MUTATION = gql `
    mutation SelectFlight($request: SelectFlightRequest) {
        selectFlight(request: $request) {
            ... on TripState {
                ${TRIP_STATE_FRAGMENT}
            }
        }
    }
`;
export function useSelectFlight(sideEffects, errorSideEffects) {
    const [selectFlightMutation, selectFlightResult] = useMutation(SELECT_FLIGHT_MUTATION, {
        onError: (err) => {
            callSideEffects(errorSideEffects, err);
        },
    });
    const selectFlight = (args) => __awaiter(this, void 0, void 0, function* () {
        const { data: mutationData } = yield selectFlightMutation({
            variables: args,
        });
        const flightTrip = mutationData === null || mutationData === void 0 ? void 0 : mutationData.selectFlight;
        if (flightTrip === null || flightTrip === void 0 ? void 0 : flightTrip.tripStateId) {
            callSideEffects(sideEffects, mutationData);
        }
    });
    return [selectFlight, selectFlightResult];
}
